import React, { useEffect, useState } from "react";
import { listOutbox, initOutbox } from "@/lib/outbox";
import PendingUploads from "@/components/PendingUploads";
import { WifiSlash, CloudArrowUp, CaretRight } from "@phosphor-icons/react";

export default function OfflineIndicator() {
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(0);
  const [panelOpen, setPanelOpen] = useState(false);

  useEffect(() => {
    const refresh = () => listOutbox().then((l) => setPending(l.length)).catch(() => {});
    const on = () => { setOnline(true); refresh(); };
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    const stop = initOutbox(() => refresh());
    const t = setInterval(refresh, 5000);
    refresh();
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); stop(); clearInterval(t); };
  }, []);

  if (online && !pending) return null;
  return (
    <>
      <button type="button" data-testid="offline-indicator"
        onClick={() => pending && setPanelOpen(true)}
        className={`w-full flex items-center justify-center gap-2 text-center text-xs font-bold py-1.5 px-3 ${online ? "bg-amber-400 text-equipr-black" : "bg-gray-800 text-white"} ${pending ? "cursor-pointer" : "cursor-default"}`}>
        {!online ? (
          <><WifiSlash size={14} weight="bold" /> Offline — entries are saved on this device and sent when back in coverage{pending ? ` (${pending} waiting)` : ""}.</>
        ) : (
          <><CloudArrowUp size={14} weight="bold" /> Sending {pending} saved {pending === 1 ? "entry" : "entries"}…</>
        )}
        {pending > 0 && <span className="inline-flex items-center gap-0.5 underline">View <CaretRight size={11} weight="bold" /></span>}
      </button>
      <PendingUploads open={panelOpen} onClose={() => setPanelOpen(false)} />
    </>
  );
}
